// Smoothly scrolls the window to a target element by id using an eased
// animation. Recomputes the destination every frame so scroll-triggered
// layout shifts (lazy images, FadeIn reveals) don't throw off the landing
// position. Cancels only on an active wheel gesture (desktop) — on mobile the
// launching tap must not cancel the scroll.
export function smoothScrollToId(
  id: string,
  opts: { offset?: number; duration?: number } = {},
) {
  const { offset = 24, duration = 1200 } = opts
  const target = document.getElementById(id)
  if (!target) return

  const startY = window.scrollY || window.pageYOffset
  let startTime: number | null = null
  let cancelled = false

  const easeInOutCubic = (t: number) =>
    t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2

  const destOf = () =>
    target.getBoundingClientRect().top +
    (window.scrollY || window.pageYOffset) -
    offset

  const cancel = () => {
    cancelled = true
    window.removeEventListener('wheel', cancel)
  }
  window.addEventListener('wheel', cancel, {
    passive: true,
  })

  const step = (now: number) => {
    if (cancelled) return
    if (startTime === null) startTime = now
    const progress = Math.min((now - startTime) / duration, 1)
    const eased = easeInOutCubic(progress)
    const nextY = startY + (destOf() - startY) * eased
    window.scrollTo(0, nextY)
    if (progress < 1) {
      requestAnimationFrame(step)
    } else {
      window.removeEventListener('wheel', cancel)
      setTimeout(() => {
        if (!cancelled) window.scrollTo(0, destOf())
      }, 80)
    }
  }
  requestAnimationFrame(step)
}
